import {observable} from "mobx";

export default class StockStore {
    storeId: string;
    @observable isActive: boolean;
    @observable hasChanges: boolean = false;
    onChange: () => void;

    constructor(storeId: string, isActive: boolean, onChange: () => void) {
        this.storeId = storeId;
        this.isActive = isActive;
        this.onChange = onChange;
    }

    changeActive(value: boolean) {
        this.isActive = value;
        this.hasChanges = true;
        this.onChange();
    }
}
